module.exports = __webpack_public_path__ + "static/media/29ADMSPC26.c73ba330.jpg";